import { AxiosRequest } from 'src/lib/axios/Axios';
import { EditPublicationPayload, UpdatePublicationResult } from './types';

export const updatePublication = async (
  payload: EditPublicationPayload,
): Promise<UpdatePublicationResult> => {
  const response = await AxiosRequest.put<UpdatePublicationResult>(`/publications/${payload.publicationId}`, payload);
  return response.data;
};
